import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { PaymentMethodAlertDialogComponent } from '..';
import { PaymentMethodAlertService } from './payment-method-alert.service';

@NgModule({
  imports: [MatDialogModule, PaymentMethodAlertDialogComponent],
  providers: [PaymentMethodAlertService],
})
export class PaymentMethodAlertServiceModule {}
